// @ngInject
function AcpContactCsComponentCtrl($scope, nsUtil, $window) {
  $scope.shouldShowTitle = function () {
    if (!nsUtil.isDefined($scope.showTitle)) {
      return true;
    }

    return $scope.showTitle === 'true';
  };

  // open link in mobile browser instead of app
  $scope.openExternalLink = function (e) {
    if (navigator && navigator.userAgent.includes('reactNativeWebview')) {
      e.preventDefault();
      if (e.target && e.target.href) {
        $window.ReactNativeWebView.postMessage(
          JSON.stringify({ externalLink: e.target.href })
        );
      }
    }
  };
}

export default AcpContactCsComponentCtrl;
